module.exports = __webpack_public_path__ + "img/323-9f9f4f.png";